import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { sidebarAutoCollapseWidth } from '../../shared/constants/constants';

@Injectable({
    providedIn: 'root',
})
export class BreakpointObserverService {
    isSmallDevice$: Observable<boolean>;

    /**
     * Returns an Observable that emits true if the sidebar navigation defined in AppComponent is auto-collapsed (and false otherwise)
     */
    get isSidebarCollapsed$(): Observable<boolean> {
        return this.isSidebarCollapsed$$.asObservable();
    }

    private isSmallDevice$$ = new BehaviorSubject(false);
    private isSidebarCollapsed$$ = new Subject<boolean>();

    constructor(breakpointObserver: BreakpointObserver) {
        this.isSmallDevice$ = this.isSmallDevice$$.asObservable();

        breakpointObserver
            .observe([`(max-width: ${sidebarAutoCollapseWidth}px)`])
            .pipe(
                tap((state: BreakpointState) => {
                    if (state.matches) {
                        this.isSidebarCollapsed$$.next(true);
                        this.isSmallDevice$$.next(true);
                    } else {
                        this.isSidebarCollapsed$$.next(false);
                        this.isSmallDevice$$.next(false);
                    }
                }),
            )
            .subscribe();
    }
}
